





































































import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import PinInput from '@/modules/shared/components/panel/PinInput.vue'
import { ModelSync, Prop, Watch } from 'vue-property-decorator'
import UserPhoneEditForm from '@/modules/user/components/shared/phone-verification/UserPhoneEditForm.vue'
import UserPhoneVerifyForm from '@/modules/user/components/shared/phone-verification/UserPhoneVerifyForm.vue'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'
import InitialPropsStore from '@/modules/common/layout/store/initial-props.store'
import CountDownStore from '@/modules/common/coutn-down/store/countDown.store'

@Component({
  components: {
    UserPhoneVerifyForm,
    UserPhoneEditForm,
    PinInput,
    AlertNotification,
    BaseButton,
    BaseInput,
    Modal
  }
})
export default class UserPhoneVerificationModal extends Vue {
  constructor(
    private readonly userBootUseCase: UserBootUseCase,
    private readonly initialPropsStore: InitialPropsStore,
    private readonly countDownStore: CountDownStore
  ) {
    super()
  }

  @Prop() phone!: string
  @Prop({ default: 0 }) delay!: number
  @ModelSync('value', 'change', { type: Boolean, default: true }) modelValue!: boolean
  storageKey: string = 'niknevis_phone_verification_show_date'

  phoneNumber = this.phone
  phoneVerifyModalShow = false
  //modals
  editPhoneModal = true
  verifyPhoneModal = false
  //timer
  verifyTimeOut = false
  timerDuration = 60

  mounted() {
    //showPhoneVerifyModal
    setTimeout(() => {
      if (this.canShow()) this.phoneVerifyModalShow = this.phoneVerifyModalShowStatus()
    }, this.delay)
  }

  canShow() {
    let lastShow = localStorage.getItem(this.storageKey)
    const today = dayjs(new Date())
    if (!lastShow) {
      localStorage.setItem(this.storageKey, today.toString())
      return true
    } else {
      if (today.diff(lastShow, 'day') >= 3) {
        localStorage.setItem(this.storageKey, today.toString())
        return true
      } else return false
    }
  }

  @Watch('modelValue')
  onChangeModal(newVal) {
    this.editPhoneModal = newVal
  }

  onEdited(event) {
    if (event) {
      this.countDownStore.resetTimer(this.timerDuration)
      this.editPhoneModal = false
      this.verifyPhoneModal = true
    }
  }

  onVerified(event) {
    if (event) this.verifyPhoneModal = false
  }

  onResend(event) {
    if (event) {
      this.countDownStore.resetTimer(this.timerDuration)
      this.countDownStore.setTimer()
    }
  }

  onPhoneEdit() {
    this.editPhoneModal = true
    this.verifyPhoneModal = false
    this.verifyTimeOut = false
  }

  phoneVerifyModalShowStatus() {
    dayjs.extend(isToday)
    return this.initialPropsStore.initialProps
      && this.initialPropsStore.initialProps.verification_status.sms_notice === false
      && this.initialPropsStore.initialProps.orig_user === null
      && !dayjs(this.userBootUseCase.user.created_at).isToday()
  }

}
